import { render, staticRenderFns } from "./Carousel3D.vue?vue&type=template&id=79391ee2&"
import script from "./Carousel3D.vue?vue&type=script&lang=ts&"
export * from "./Carousel3D.vue?vue&type=script&lang=ts&"
import style0 from "./Carousel3D.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
